// Данные шторки позиции по её складу и товару: история по дням, «Используется в блюдах». Новая позиция — новый
// запрос, ответ на прежнюю не применяется. fetcher(token, { organization, store, product, days })
import { useEffect, useState } from 'react';

export function useStockRequest(item, fetcher, days) {
  const [state, setState] = useState({ data: null, failed: false });
  const token = localStorage.getItem('token');
  useEffect(() => {
    if (!item || !token) return undefined;
    let alive = true;
    setState({ data: null, failed: false });
    fetcher(token, { organization: item.organizationId, store: item.storeId, product: item.product_id, days })
      .then((data) => alive && setState({ data, failed: false }))
      .catch(() => alive && setState({ data: null, failed: true }));
    return () => {
      alive = false;
    };
  }, [item, token, fetcher, days]);
  return state;
}
